import type { FilterName, FilterValue } from "../../types/dreson";

import { DRESON_PREFIX, FILTER_NAME, FilterSuffixMap } from "../../types/dreson/constants";
import { util } from "../util";

export class DresonFilterMatch {
  private _prefix: DRESON_PREFIX | undefined;
  private _name: FilterName;
  private _value: FilterValue;

  constructor(matches: RegExpMatchArray) {
    this.validate(matches);
    this._prefix = this.filterPrefix(matches[1]);
    this._name = this.filterName(matches[2]);

    if (matches[1] == DRESON_PREFIX.SUCHBEGRIFF) {
      this._value = decodeURI(matches[2]);
    } else {
      this._value = this.filterValue(matches[3]);
    }
  }

  get name(): FilterName {
    return this._name;
  }

  get value(): FilterValue {
    return this._value;
  }

  validate(matches: RegExpMatchArray) {
    if (matches.length < 4) {
      throw new Error("Dreson parsing failed");
    }
  }

  private filterPrefix(value: string): DRESON_PREFIX | undefined {
    if (Object.values(DRESON_PREFIX).includes(value as DRESON_PREFIX)) {
      return value as DRESON_PREFIX;
    }
    return;
  }

  private filterName(value: string): FilterName {
    if (this._prefix == DRESON_PREFIX.SUCHBEGRIFF) {
      return this._prefix;
    }
    return util.string.unslugify(util.string.capitalize(value));
  }

  private filterValue(value: string): FilterValue {
    if (this._prefix == DRESON_PREFIX.AB || this._prefix == DRESON_PREFIX.BIS) {
      return { [`${this._prefix}`]: value };
    }
    if (value) {
      return util.string.unslugify(value).split(".").map(this.addSuffix.bind(this));
    }
    return this.addSuffix(value);
  }

  private addSuffix(this: DresonFilterMatch, value: string): string {
    const suffix: string = FilterSuffixMap[this._name as FILTER_NAME] || "";
    return `${value}${suffix}`;
  }
}
